"use strict";

exports.additiveSymmetric = require('./distances/additiveSymmetric');
exports.avg = require('./distances/avg');
exports.bhattacharyya = require('./distances/bhattacharyya');
exports.canberra = require('./distances/canberra');
exports.chebyshev = require('./distances/chebyshev');
exports.clark = require('./distances/clark');
exports.czekanowski = require('./distances/czekanowski');
exports.dice = require('./distances/dice');
exports.divergence = require('./distances/divergence');
exports.euclidean = require('ml-distance-euclidean');
exports.fidelity = require('./distances/fidelity');
exports.gower = require('./distances/gower');
exports.harmonicMean = require('./distances/harmonicMean');
exports.hellinger = require('./distances/hellinger');
exports.innerProduct = require('./distances/innerProduct');
exports.intersection = require('./distances/intersection');
exports.jaccard = require('./distances/jaccard');
exports.jeffreys = require('./distances/jeffreys');
exports.jensenDifference = require('./distances/jensenDifference');
exports.jensenShannon = require('./distances/jensenShannon');
exports.kdivergence = require('./distances/kdivergence');
exports.kulczynski = require('./distances/kulczynski');
exports.kullbackLeibler = require('./distances/kullbackLeibler');
exports.kumarHassebrook = require('./distances/kumarHassebrook');
exports.kumarJohnson = require('./distances/kumarJohnson');
exports.lorentzian = require('./distances/lorentzian');
exports.manhattan = require('./distances/manhattan');
exports.matusita = require('./distances/matusita');
exports.minkowski = require('./distances/minkowski');
exports.motyka = require('./distances/motyka');
exports.neyman = require('./distances/neyman');
exports.pearson = require('./distances/pearson');
exports.probabilisticSymmetric = require('./distances/probabilisticSymmetric');
exports.ruzicka = require('./distances/ruzicka');
exports.soergel = require('./distances/soergel');
exports.sorensen = require('./distances/sorensen');
exports.squared = require('./distances/squared');
exports.squaredChord = require('./distances/squaredChord');
exports.squaredEuclidean = require('ml-distance-euclidean').squared;
exports.taneja = require('./distances/taneja');
exports.tanimoto = require('./distances/tanimoto');
exports.topsoe = require('./distances/topsoe');
exports.tree = require('ml-tree-similarity');
exports.waveHedges = require('./distances/waveHedges');



//////////////////
// WEBPACK FOOTER
// ./~/ml-distance/src/distances.js
// module id = 72
// module chunks = 0